import * as yup from "yup";

let createTicketValidationForm = yup.object().shape({
  queue: yup.string().required("Subject is required"),
  priority: yup.string().required("Priority is required"),
  description: yup.string().required("Description is required"),
});

let createDeliveryChargeValidation = yup.object().shape({
  pickup_branch: yup.string().required("Pickup Branch is required"),
  destination_city: yup.string().required("Destination City is required"),
  base_weight: yup.string().required("Base weight is required"),
  base_price: yup.string().required("Base price is required"),
  price_for_exceed_weight: yup
    .string()
    .required("Price of exceed weight is required"),
});

let createDeliveryChargeTemplateValidation = yup.object().shape({
  name: yup.string().required("Name is required"),
  base_weight: yup
    .number()
    .min(1, "Number must be at least 1")
    .typeError("Base Weight must be a number")
    .required("Base Weight is required"),
  base_piece: yup
    .number()
    .typeError("Base Piece must be a number")
    .min(1, "Number must be at least 1")
    .required("Base Piece is required"),
  base_volume: yup
    .number()
    .typeError("Base volume must be a number")
    .min(1, "Number must be at least 1")
    .required("Base Volume is required"),
});
let groupValidationForm = yup.object().shape({
  name: yup.string().required("Group Name is required"),
  code: yup.string().required("Currency is required"),
});
export {
  createTicketValidationForm,
  createDeliveryChargeValidation,
  createDeliveryChargeTemplateValidation,
  groupValidationForm
};
